<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsContainer',
  
})
</script>
<template>
  <div
    v-if="isShow"
    class="tlbs-container"
  >
    <slot />
  </div>
</template>

<script setup lang="ts"  name="TlbsContainer">
interface Props {
  isShow?: boolean
}

withDefaults(defineProps<Props>(), {
  isShow: true,
});
</script>
